
app.factory(
    'FlaneriesService', ['LocalStorage', 'ApiService', '$rootScope', FlaneriesService]
);

function FlaneriesService(LocalStorage, ApiService, $rootScope) {


    //get empty step
    self.GetEmptyStep = function (itiid, lang) {
        var request = ApiService.post("/api/ItineraryApi/GetEmptyStep?itiid=" + itiid + "&lang=" + lang);
        return request;
    }


    //Get Single 
    self.getFlaneries = function (id, lang, lang2, index, sortKey, reverse, filter, countryId, CityId, UpdateDate, CreationDate, statusId, clid, langCode) {
        return ApiService.get("/api/ItineraryApi/GetFlaneries?id=" + id + "&lang=" + lang + "&lang2=" + lang2 + "&index=" + index + "&sortKey=" + sortKey + "&reverse=" + reverse + "&filter=" + filter + "&countryId=" + countryId + "&CityId=" + CityId + "&UpdateDate=" + UpdateDate + "&CreationDate=" + CreationDate + "&statusId=" + statusId + "&clid=" + clid + "&langCode=" + langCode);
    }

    //Get  Itinerary List
    self.GetItineraryList = function (zoneId, qcId, itemsPerPage, pagenumber, sortKey, reverse, lang, isTopBarActive, sparams, sgparams, searchText, AdvancedSearch) {
        var request = ApiService.post("/api/ItineraryApi/GetItineraryList?zoneId=" + zoneId + "&qc=" + qcId + "&itemsPerPage=" + itemsPerPage + "&pagenumber=" + pagenumber + "&sortKey=" + sortKey + "&reverse=" + reverse + "&lang=" + lang + "&itba=" + isTopBarActive + "&sparams=" + sparams + "&sgparams=" + sgparams + "&st=" + encodeURIComponent(searchText), AdvancedSearch);
        return request;
    }


    //Get  Itinerary List
    self.GetItinerary24List = function (zoneId, qcId, itemsPerPage, pagenumber, sortKey, reverse, lang) {
        return ApiService.get("/api/ItineraryApi/GetItinerary24List?zoneId=" + zoneId + "&qc=" + qcId + "&itemsPerPage=" + itemsPerPage + "&pagenumber=" + pagenumber + "&sortKey=" + sortKey + "&reverse=" + reverse + "&lang=" + lang);
    }


    //update Itinerary
    self.UpdateItineraryTranslation = function (Itinerary) {
        var request = ApiService.post("/api/ItineraryApi/UpdateItineraryTranslation", Itinerary);
        return request;
    }

    //update Itinerary
    self.UpdateItineraryStepTranslation = function (vm, index) {
        var request = ApiService.post("/api/ItineraryApi/UpdateItineraryStepTranslation?iti=" + vm + "&stepindex=" + index, vm);
        return request;
    }

    //Update Description 
    self.UpdateDescriptionIti = function (index, Itinerary) {

        var request = ApiService.post("/api/ItineraryApi/UpdateDescriptionTranslation?index=" + index, Itinerary);
        return request;
    }

    //Update Description  Status
    self.UpdateDescriptionStatusIti = function (Itinerary, lang2, status) {
        var request = ApiService.post("/api/ItineraryApi/UpdateDescriptionTranslationStatus?lang2=" + lang2 + "&statusid=" + status, Itinerary);
        return request;
    }

    //Update Itinerary  status
    self.UpdateItineraryStatus = function (status, objectId, lang) {
        var request = ApiService.post("/api/ItineraryApi/UpdateDistrictStatus?id=" + objectId + "&status=" + status + "&lang=" + lang);
        return request;
    }


    //Translate Description 
    self.TranslateDescription = function (Itinerary, lang, lang2, index) {
        var request = ApiService.post("/api/ItineraryApi/TranslateDescription?lang=" + lang + "&lang2=" + lang2 + "&index=" + index, Itinerary);
        return request;
    }

    //Translate Description 
    self.RemoveStep = function (Itinerary, stepid, lang) {
        var request = ApiService.post("/api/ItineraryApi/RemoveStep?lang=" + lang + "&stepid=" + stepid, Itinerary);
        return request;
    }

    //Create
    self.CreateNewItinerary = function (ItineraryVm) {
        var st = JSON.stringify(ItineraryVm);
        var request = ApiService.post("/api/ItineraryApi/CreateNewItinerary", st);
        return request;
    }

    //GetItineraryForCreation
    self.GetItineraryForCreation = function (qc, lang) {
        var request = ApiService.get("/api/ItineraryApi/GetItineraryForCreation?qc=" + qc + "&lang=" + lang);
        return request;
    }

    //GetItineraryPreview    
    self.GetItineraryPreview = function (id, lang) {
        var request = ApiService.get("/api/ItineraryApi/GetItineraryPreview?id=" + id + "&lang=" + lang);
        return request;
    }

    //Create New Description and associate with Iti
    self.CreateNewDescriptionForIti = function (descForCreation) {
        $rootScope.ShowIconLoading();
        var st = JSON.stringify(descForCreation);
        var request = ApiService.post("/api/DescriptionApi/CreateNewDescriptionForObject/", st)
            .then(
                function success(data) {
                    $rootScope.returnNewDesc = angular.copy(data.data);
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    return self;
}
